import { sendGoogleGoal } from 'www/utils'

sendGoogleGoal('visit_doctor_page')
